export function webSocket(host, RizkConfig) {
  const socket = new WebSocket(`wss://${host}/ws?userId=${RizkConfig.userId}&sessionId=${RizkConfig.sessionId}`);

  // Connection opened event
  socket.addEventListener('open', function (_event) {
    console.log('Connected to WS Server');
    socket.send('Hello Server!');
  });

  // Listen for messages
  socket.addEventListener('message', function (event) {
    try {
      const json = JSON.parse(event.data);

      if (json.type in dataHandlers) {
        dataHandlers[json.type] && dataHandlers[json.type](json);
      }
    } catch (e) {
      console.log('json fail', e);
    }
  });

  // Listen for possible errors
  socket.addEventListener('error', function (event) {
    console.log('WebSocket error: ', event);
  });

  // Listen for when the connection is closed
  socket.addEventListener('close', function (event) {
    console.log('WebSocket connection closed: ', event);
  });

  return {
    sendMessage: function (data, type, clientID, to) {
      var payload = {
        from: RizkConfig.userId,
        to: to || RizkConfig.userId,
        clientID: clientID,
        userToken: RizkConfig.userToken || '',
        type: type,
        data: data,
      };

      if (RizkConfig.logged) {
        socket.send(JSON.stringify(payload));
      }
    },
  };
}

const dataHandlers = {
  'first-deposit': function () {
    var obj = {
      forceDisplay: true,
      minTimeOnPage: 0,
      sampleFactor: 0.03,
      properties: {
        userId: RizkConfig.userId || null,
        locale: RizkConfig.locale + '-x-gig' || null,
        event: 'deposit',
        thank_you_message: null,
      },
    };

    switch (RizkConfig.locale) {
      case 'fi':
        obj.properties.thank_you_message =
          'Kiitos paljon, arvostamme antaamaasi palautetta. Sinun avullasi voimme tarjota parempia pelikokemuksia kaikille!';
        obj.properties.questionProductName = 'Rizkiä';
        break;
      case 'no':
        obj.properties.thank_you_message =
          'Takk så mye for din tilbakemelding! Din mening er veldig viktig for oss og med din hjelp så kan vi skape en enda bedre spilleopplevele for alle!';
        obj.properties.locale = 'nb-x-gig';
        break;
      case 'sv':
        obj.properties.thank_you_message =
          'Tack för din feedback! Din åsikt är viktig för oss. Med din hjälp så kan vi skapa en fantastisk spelupplevelse för alla!';
        break;
      case 'de':
        obj.properties.thank_you_message =
          'Vielen Dank! Wir freuen uns sehr über jede Rückmeldung. Dank dir, können wir uns weiterentwickeln und verbessern und ein besseres Onlinegamingerlebnis schaffen!';
        break;
      default:
        obj.properties.thank_you_message =
          'With your help, we can create an even better online gaming experience for everyone!';
        break;
    }

    try {
      if (RizkConfig.locale !== 'es' && RizkConfig.locale !== 'hr') {
        delighted.survey(obj);
      }
    } catch (e) {
      console.log('delighted exception', e);
    }
    console.log('delighted:first-deposit');
  },
  userDataRequired: function (json) {
    // Might need some day
    console.log('userDataRequired from node', json);
  },
  transaction: function (json) {
    if (json.trxtype === 1) {
      if (!Rizk.isFeatureOn('paas-cashier', RizkConfig) || !Rizk.isFeatureActive('paas-cashier', RizkConfig)) {
        Rizk.Deposit.showReceipt();
        Rizk.Deposit.track(json.amount, json.currency, json.depocount);
      }
    }
  },
  withdrawal: function () {
    var obj = {
      forceDisplay: true,
      minTimeOnPage: 0,
      sampleFactor: 0.03,
      properties: {
        userId: RizkConfig.userId || null,
        locale: RizkConfig.locale + '-x-gig' || null,
        event: 'withdrawal',
        thank_you_message: null,
      },
    };

    switch (RizkConfig.locale) {
      case 'fi':
        obj.properties.thank_you_message =
          'Kiitos paljon, arvostamme antaamaasi palautetta. Sinun avullasi voimme tarjota parempia pelikokemuksia kaikille!';
        obj.properties.questionProductName = 'Rizkiä';
        break;
      case 'no':
        obj.properties.thank_you_message =
          'Takk så mye for din tilbakemelding! Din mening er veldig viktig for oss og med din hjelp så kan vi skape en enda bedre spilleopplevele for alle!';
        obj.properties.locale = 'nb-x-gig';
        break;
      case 'sv':
        obj.properties.thank_you_message =
          'Tack för din feedback! Din åsikt är viktig för oss. Med din hjälp så kan vi skapa en fantastisk spelupplevelse för alla!';
        break;
      case 'de':
        obj.properties.thank_you_message =
          'Vielen Dank! Wir freuen uns sehr über jede Rückmeldung. Dank dir, können wir uns weiterentwickeln und verbessern und ein besseres Onlinegamingerlebnis schaffen!';
        break;
      default:
        obj.properties.thank_you_message =
          'With your help, we can create an even better online gaming experience for everyone!';
        break;
    }

    if (RizkConfig.locale !== 'es' && RizkConfig.locale !== 'hr') {
      delighted.survey(obj);
    }
    console.log('delighted:withdrawal');
  },
  bar: function (json) {
    console.log('data.type=bar msg from websocket:', json);
    if (Rizk.isFeatureActive('level-up-bar', RizkConfig) === false) {
      return;
    }
    if (json && json.percent !== undefined) {
      Rizk.ProgressBar.update(json.percent, json.level);
    }
  },
  wallet: function (json) {
    console.log('wallet msg from websocket:', json);
    if (json && json.balance !== undefined) {
      Rizk.Wallet.update(json.bonus, parseFloat(json.balance) + parseFloat(json.real));
    }
  },
  'get-wallet': function () {
    Rizk.Wallet.get();
  },
  'bonus-maxbet': function () {
    showAjaxModal('bonus-maxbet');
  },
  reward: function (json) {
    console.log('reward msg from websocket:', json);
    if (json === undefined || json.count === undefined) {
      return;
    }
    if (Rizk.Rewards.active && json.count > 0 && json.itemData) {
      Rizk.Rewards.addItem(json.itemData);
    } else {
      Rizk.SideMenu.updateRewardCount(json.count);
    }
    var e = new CustomEvent('rizk-item', {
      detail: json,
    });
    document.dispatchEvent(e);
  },
  'reward-delete': function (json) {
    console.log('reward-delete msg from websocket: ', json);
    if (json && json.count !== undefined) {
      console.log('reward delete notification', json);
      if (json.itemData) {
        if (json.itemData.notificationType === 'multi') {
          Rizk.Rewards.deleteItems(json.itemData.type);
        } else {
          Rizk.Rewards.deleteItem(json.itemData);
          Rizk.Deposit.deleteItem(json.itemData);
        }
      } else if (json.count > 0) {
        Rizk.SideMenu.updateRewardCount(json.count);
      }
    }
  },
  jackpot: function (json) {
    console.log('jackpot msg from websocket:', json);
    if (json && json.value && Rizk.Cave) {
      Rizk.Cave.updateJackpot(json.value);
    }
  },
  showNotification: function (data) {
    if (Rizk.isFeatureActive('account-inbox', RizkConfig) === false) {
      return;
    }
    Rizk.NotificationController.show(data);
  },
  terms: function (json) {
    showAcceptTermsModal();
  },
  'race-start': function (json) {
    console.log('race-start', json);
    Rizk.Race.startRace(json);
    Rizk.GameView.handleRace(json);
  },
  'race-finish': function (json) {
    console.log('race-finish', json);
    // Rizk.Race.finishRace(json)
    Rizk.GameView.finishRace(json);
  },
  'race-points': function (json) {
    if (json && json.points) {
      console.log('race-points', json);
      var raceId, p;
      for (raceId in json.points) {
        p = json.points[raceId];
        if (Rizk.Race) {
          Rizk.Race.updateRacePoints(parseInt(raceId), p);
          Rizk.Race.updateOptinCount(p[0] && p[0].racingUsers, raceId);
        }
      }
    }
  },
  'race-user-stats': function (json) {
    if (json) {
      console.log('race-user-stats', json);
      if (RizkConfig.inGame) {
        Rizk.GameView.updateRaceStats(json);
      } else {
        Rizk.Race.updateRaceStats(json);
      }
    }
  },
  'race-user-opt-ins': function (json) {
    console.log('race-user-opt-ins', json);
    // json.races == array of raceIds
  },
  'race-game-not-allowed': function (json) {
    Rizk.Race.raceNotAllowed(json);
  },
  'race-stake-too-low': function (json) {
    console.log('race-stake-too-low', json);
    Rizk.NotificationController.show({
      timeout: 10000,
      message: {
        en: Rizk.Translations.get('race_stake_too_low') + RizkConfig.currency + ' ' + json.minStake,
      },
    });
  },
  kyc: function () {
    Rizk.NotificationController.show({
      timeout: 10000,
      message: { en: Rizk.Translations.get('kyc_ok') },
    });
  },
  sportsWin: function (json) {
    Rizk.NotificationController.show({
      timeout: 10000,
      message: {
        en: Rizk.Translations.get('sports_win')
          .replace('%currency%', Rizk.currencySymbol(RizkConfig.currency))
          .replace('%WonAmount%', json.WonAmount.toPrecision(3)),
      },
    });
  },
  block_state_change: function (payload) {
    var blockTypes = payload.activeBlocks.reduce(function (reducer, obj) {
      var block = obj.BlockReason || obj.BlockType;
      if (typeof block === 'string') {
        block = block.replace(' ', '-').toLowerCase();
      }
      reducer.push(block);
      return reducer;
    }, []);
    var noBlocks = blockTypes.length === 0;
    if (
      (RizkConfig.kycStatus !== '0' && noBlocks) ||
      (RizkConfig.kycStatus !== '0' && blockTypes.indexOf('unverified-account') === -1)
    ) {
      ajax(
        'cache/update/kyc',
        function (res) {
          if (res.status === 200) {
            var response = JSON.parse(res.response);
            if (response.status === 'success') {
              RizkConfig.kycStatus = '0';

              var id = 'lccp-lock';
              var btn = {
                text: 'continue',
                classname: 'rizk-btn green-btn',
                click: function (e) {
                  e.preventDefault();
                  window.location = `${location.origin}/${
                    RizkConfig.locale
                  }/casino-games/#${Math.random().toString(36).substring(7)}`;
                },
              };
              var modal = Rizk.ModalFactory.createNotificationModal(
                {
                  id: id,
                  heading: Rizk.Translations.get('lccp_modal_header', RizkConfig.locale, true),
                  text: Rizk.Translations.get('lccp_verifed', RizkConfig.locale, true),
                  buttons: [btn],
                },
                false
              );
              Rizk.ModalController.addModal(modal, false);
              Rizk.ModalController.showModal(id, 4, true);
            }
          }
          console.log(res);
        },
        JSON.stringify({ kyc_status: true }),
        true,
        false,
        'application/json'
      );
    }
  },
  kycupdate: handleKYCChange,
  kycapprovalsupdate: handleKYCChange,
  kycapprovalstatuschange: handleKYCChange,
  'close-active-game': function (data) {
    data.type = 'close-active-game';
    Rizk.GameView.handleCrossWindowMessage(data);
  },
  'close-active-notification': function (data) {
    data.type = 'close-active-notification';
    Rizk.GameView.handleCrossWindowMessage(data);
  },
  games: function (payload) {
    Object.keys(Rizk.gameStatsCounters).forEach((id) => {
      const counter = Rizk.gameStatsCounters[id];
      console.log(counter);
      counter.updateStats(payload);
    });
  },
  gamelimitnotificationpercentage: function ({ data }) {
    Rizk.GameView.handleLimitReached(data);
  },
  'reality-check': function (payload) {
    const options = { redirectToLobby: true };

    Rizk.HardRealityCheck.showModal(payload, options);
  },
  'rg-trigger': function (payload) {
    Rizk.rgTriggers.getTriggersWithTranslations(payload.userId, payload.triggerType);
  },
  sowTrigger: function () {
    if (Rizk.isFeatureOn('sow-trigger', RizkConfig) && Rizk.isFeatureActive('sow-trigger', RizkConfig)) {
      if (window && window.sow) {
        window.sow.show('RESUBMIT_SOWQ');
      }
    }
  },
  paymenttransactionaction: function (payload) {
    Rizk.Deposit.transactionEvent(payload.data);
  },
};

// kycupdate
// kycapprovalsupdate
// kycapprovalstatuschange
function handleKYCChange(payload) {
  // should probaly do more with this, V2 maybe??
  Rizk.getKycStatus().then(function (amlStatus) {
    console.log(amlStatus);
  });
}
